<template>
  <b-row>
    <b-col md="6">
      <b-form-group class="mb-0">
        <b-form-select
          id="order"
          :class="sortDropdownClass"
          size="sm"
          v-model="selectedSortMethod"
          :options="sortMethods"
          @change="$emit('sort', selectedSortMethod)"
          ></b-form-select>
      </b-form-group>
    </b-col>
    <b-col md="6">
      <b-form-group class="mb-0">
        <b-form-select
          id="itemsPerPage"
          size="sm"
          v-model="selectedPriceFilters"
          :options="priceFilters"
          @change="$emit('priceFilter', selectedPriceFilters)"
          >
          </b-form-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import formMixin from '../../shared/mixins/search_forms_other'
import viewMixin from '../../shared/mixins/search_views'
export default {
  name: 'SortFields',
  mixins: [formMixin, viewMixin]
}
</script>
